<template>

  <footer class="new-footer-wrap-full">
    <div class="new-Custm-container">
      <div class="flex-list-all-foot-section">

        <div class="flex_footer_section-1">

          <div class="left-foot-logo-with-contat">
            <div class="footer-logo-with-text-new-custm">
              <div class="textwidget">
                <div class="footer-logo"><img src="https://assets.upstox.com/website/images/upstox-footer-logo.png"
                    alt="footer-logo" /></div>
                <p>30th Floor, Sunshine Tower, Senapati Bapat Marg, Dadar (W), Mumbai, Maharashtra 400013</p>
                <p>Call:<br />
                  <span class="phone"><a href="tel:91-7092362098">91-7092362098</a></span>
                </p>
                <p>E-mail:<br />
                  <span class="phone"><a href="mailto:support@upstox.icu">support@upstox.icu</a></span>
                </p>
              </div>
              <div class="menu-footer-social-container">
                <ul id="menu-footer-social" class="menu">
                  <li id="menu-item-8129"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-8129"><a><img
                        src="https://assets.upstox.com/website/images/fbtop.webp" alt="facebook" loading="lazy" /></a>
                  </li>
                  <li id="menu-item-8130"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-8130"><a><img
                        src="https://assets.upstox.com/website/images/twittertop.webp" alt="twitter"
                        loading="lazy" /></a></li>
                  <li id="menu-item-32935"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-32935"><a><img
                        src="https://assets.upstox.com/website/images/telegramtop.webp" alt="telegram"
                        loading="lazy" /></a></li>
                  <li id="menu-item-32936"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-32936"><a><img
                        src="https://assets.upstox.com/website/images/linkedintop.webp" alt="linkedin"
                        loading="lazy" /></a></li>
                  <li id="menu-item-8921"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-8921"><a><img
                        src="https://assets.upstox.com/website/images/yttop.webp" alt="youtube" loading="lazy" /></a>
                  </li>
                  <li id="menu-item-11637"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-11637"><a><img
                        src="https://assets.upstox.com/website/images/instatop.webp" alt="instagram"
                        loading="lazy" /></a></li>
                  <li id="menu-item-49602"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49602"><a target="_blank"
                      rel="noopener" href="https://wa.me/+917092362098"><img
                        src="https://assets.upstox.com/website/images/whatsapptop.webp" alt="whatsapp"
                        loading="lazy" /></a></li>
                </ul>
              </div>
            </div>
          </div>

          <div class="right-foot-logo-with-contat">
            <div class="textwidget">
              <div class="playstore-section-mob">
                <div class="left-playstore_1">
                  <p>Download the mobile application today</p>
                  <ul class="playstore_listing-icon">
                    <li><a href="https://play.google.com/store/apps/details?id=com.jobvim.expensetoday&pcampaignid=web_share"><br />
                        <img src="https://assets.upstox.com/website/images/google-footer-logo.webp"
                          alt="Play store" /><br />
                      </a></li>
                    <li><a href="https://apps.apple.com/cn/app/mioduvac/id6745430658"><br />
                        <img src="https://assets.upstox.com/website/images/apple-footer-logo.webp"
                          alt="App store" /><br />
                      </a></li>
                  </ul>
                </div>
                <div class="right-playstore_1"><img src="https://assets.upstox.com/website/images/footer-qr-code.webp"
                    alt="qr-img" /></div>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-support-mobile visible-xs visible-sm" id="footer-support-mobile">
          <ul class="footer-tabs">
            <li class="tab"><a href="#lcMobile" val="#lcMobile"><span>Popular Stocks</span> <span
                  class="expand_icon dashicons-plus"></span></a></li>
            <ul id="lcMobile" class="hiding pane-container">
              <li>
                <div class="tab-content">
                  <div class="container tab-pane ">
                    <section class="widget-popular-stocks widget nav_menu-65 widget_nav_menu">
                      <p class="widget__title">Popular Stocks</p>
                      <div class="menu-footer-popular-stocks-new-container">
                        <ul id="menu-footer-popular-stocks-new" class="menu">
                          <li id="menu-item-49610"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49610"><a
                              href="/stocks/indian-railway-fin-corp-l-share-price/INE053F01010/">IRFC
                              Share Price</a></li>
                          <li id="menu-item-49611"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49611"><a
                              href="/stocks/suzlon-energy-limited-share-price/INE040H01021/">Suzlon
                              Share Price</a></li>
                          <li id="menu-item-49612"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49612"><a
                              href="/stocks/indian-renewable-energy-share-price/INE202E01016/">IREDA
                              Share Price</a></li>
                          <li id="menu-item-49613"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49613"><a
                              href="/stocks/tata-motors-limited-share-price/INE155A01022/">Tata Motors
                              Share Price</a></li>
                          <li id="menu-item-50030"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50030"><a
                              href="/stocks/penny-stocks/">Penny Stocks</a></li>
                          <li id="menu-item-49614"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49614"><a
                              href="/stocks/yes-bank-limited-share-price/INE528G01035/">Yes Bank Share
                              Price</a></li>
                          <li id="menu-item-49615"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49615"><a
                              href="/stocks/adani-enterprises-limited-share-price/INE423A01024/">Adani
                              Enterprise Share Price</a></li>
                          <li id="menu-item-49616"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49616"><a
                              href="/stocks/hdfc-bank-ltd-share-price/INE040A01034/">HDFC Bank Share
                              Price</a></li>
                          <li id="menu-item-49617"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49617"><a
                              href="/stocks/nhpc-ltd-share-price/INE848E01016/">NHPC Share Price</a>
                          </li>
                          <li id="menu-item-50031"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50031"><a
                              href="/stocks/stocks-under-10/">Stocks under 10</a></li>
                          <li id="menu-item-49618"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49618"><a
                              href="/stocks/rail-vikas-nigam-limited-share-price/INE415G01027/">RVNL
                              Share Price</a></li>
                          <li id="menu-item-49619"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49619"><a
                              href="/stocks/state-bank-of-india-share-price/INE062A01020/">SBI Share
                              Price</a></li>
                          <li id="menu-item-49620"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49620"><a
                              href="/stocks/tata-power-co-ltd-share-price/INE245A01021/">Tata Power
                              Share Price</a></li>
                          <li id="menu-item-49621"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49621"><a
                              href="/stocks/tata-steel-limited-share-price/INE081A01020/">Tata Steel
                              Share Price</a></li>
                          <li id="menu-item-50032"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50032"><a
                              href="/stocks/stocks-under-20/">Stocks under 20</a></li>
                          <li id="menu-item-49622"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49622"><a
                              href="/stocks/adani-power-ltd-share-price/INE814H01011/">Adani Power
                              Share Price</a></li>
                          <li id="menu-item-49623"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49623"><a
                              href="/stocks/one-97-communications-ltd-share-price/INE982J01020/">Paytm
                              Share Price</a></li>
                          <li id="menu-item-49624"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49624"><a
                              href="/stocks/punjab-national-bank-share-price/INE160A01022/">PNB Share
                              Price</a></li>
                          <li id="menu-item-49625"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49625"><a
                              href="/stocks/zomato-limited-share-price/INE758T01015/">Zomato Share
                              Price</a></li>
                          <li id="menu-item-50033"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50033"><a
                              href="/stocks/stocks-under-50/">Stocks under 50</a></li>
                          <li id="menu-item-49626"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49626"><a
                              href="/stocks/bharat-electronics-ltd-share-price/INE263A01024/">BEL
                              Share Price</a></li>
                          <li id="menu-item-49627"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49627"><a
                              href="/stocks/bhel-share-price/INE257A01026/">Bhel Share Price</a></li>
                          <li id="menu-item-49628"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49628"><a
                              href="/stocks/infosys-limited-share-price/INE009A01021/">Infosys Share
                              Price</a></li>
                          <li id="menu-item-49629"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49629"><a
                              href="/stocks/indian-rail-tour-corp-ltd-share-price/INE335Y01020/">IRCTC
                              Share Price</a></li>
                          <li id="menu-item-50034"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50034"><a
                              href="/stocks/stocks-under-100/">Stocks under 100</a></li>
                          <li id="menu-item-49630"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49630"><a
                              href="/stocks/life-insura-corp-of-india-share-price/INE0J1Y01017/">LIC
                              Share Price</a></li>
                          <li id="menu-item-49631"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49631"><a
                              href="/stocks/itc-ltd-share-price/INE154A01025/">ITC Share Price</a>
                          </li>
                          <li id="menu-item-49632"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49632"><a
                              href="/stocks/reliance-industries-ltd-share-price/INE002A01018/">Reliance
                              Share Price</a></li>
                          <li id="menu-item-50035"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50035"><a
                              href="/stocks/stocks-under-200/">Stocks under 200</a></li>
                          <li id="menu-item-50036"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50036"><a
                              href="/stocks/stocks-under-500/">Stocks under 500</a></li>
                          <li id="menu-item-50037"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50037"><a
                              href="/stocks/stocks-under-1000/">Stocks under 1000</a></li>
                        </ul>
                      </div>
                    </section>
                  </div>
                </div>
              </li>
            </ul>
            <li class="tab"><a href="#foMobile" val="#foMobile"><span>Indian Indices</span> <span
                  class="expand_icon dashicons-plus"></span></a></li>
            <ul id="foMobile" class="hiding pane-container">
              <li>
                <div class="tab-content">
                  <div class="container tab-pane ">
                    <section class="widget-indian-stocks widget nav_menu-66 widget_nav_menu">
                      <p class="widget__title">Indian Stocks</p>
                      <div class="menu-footer-indian-stocks-container">
                        <ul id="menu-footer-indian-stocks" class="menu">
                          <li id="menu-item-31706"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31706"><a
                              href="/indices/nifty-50-share-price/">Nifty 50</a></li>
                          <li id="menu-item-31707"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31707"><a
                              href="/indices/nifty-next-50-share-price/">Nifty Next 50</a></li>
                          <li id="menu-item-31708"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31708"><a
                              href="/indices/nifty-bank-share-price/">Nifty Bank</a></li>
                          <li id="menu-item-31709"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31709"><a
                              href="/indices/nifty-100-share-price/">Nifty 100</a></li>
                          <li id="menu-item-31710"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31710"><a
                              href="/indices/nifty-200-share-price/">Nifty 200</a></li>
                          <li id="menu-item-31711"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31711"><a
                              href="/indices/nifty-500-share-price/">Nifty 500</a></li>
                          <li id="menu-item-31712"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31712"><a
                              href="/indices/nifty-midcap-50-share-price/">Nifty Midcap 50</a></li>
                          <li id="menu-item-31713"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31713"><a
                              href="/indices/nifty-smlcap-50-share-price/">NIFTY SMLCAP 50</a></li>
                          <li id="menu-item-31714"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31714"><a
                              href="/indices/india-vix-share-price/">India VIX</a></li>
                          <li id="menu-item-31715"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31715"><a
                              href="/indices/sensex-share-price/">SENSEX</a></li>
                          <li id="menu-item-31716"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31716"><a
                              href="/indices/bse100-share-price/">BSE100</a></li>
                          <li id="menu-item-49636"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49636"><a
                              href="/indices/lrgcap-share-price/">BSE LargeCap</a></li>
                          <li id="menu-item-49637"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49637"><a
                              href="/indices/midcap-share-price/">BSE MidCap</a></li>
                          <li id="menu-item-49638"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49638"><a
                              href="/indices/smlcap-share-price/">BSE SmallCap</a></li>
                          <li id="menu-item-49639"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49639"><a
                              href="/indices/bse500-share-price/">BSE500</a></li>
                          <li id="menu-item-49640"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49640"><a
                              href="/indices/allcap-share-price/">BSE AllCap</a></li>
                          <li id="menu-item-49641"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49641"><a
                              href="/indices/bse200-share-price/">BSE 200</a></li>
                          <li id="menu-item-49642"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49642"><a
                              href="/indices/bseipo-share-price/">BSE IPO</a></li>
                          <li id="menu-item-49643"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49643"><a
                              href="/indices/smeipo-share-price/">BSE SME IPO</a></li>
                        </ul>
                      </div>
                    </section>
                  </div>
                </div>
              </li>
            </ul>
            <li class="tab"><a href="#ipMobile" val="#ipMobile"><span>Mutual Funds</span> <span
                  class="expand_icon dashicons-plus"></span></a></li>
            <ul id="ipMobile" class="hiding pane-container">
              <li>
                <div class="tab-content">
                  <div class="container tab-pane ">
                    <section class="widget-funds widget nav_menu-79 widget_nav_menu">
                      <p class="widget__title">funds</p>
                      <div class="menu-footer-mutual-funds-container">
                        <ul id="menu-footer-mutual-funds" class="menu">
                          <li id="menu-item-49647"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49647"><a
                              href="/mutual-funds/explore/sbi-funds/">SBI Mutual Fund</a></li>
                          <li id="menu-item-49648"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49648"><a
                              href="/mutual-funds/explore/hdfc-funds/">HDFC Mutual Fund</a></li>
                          <li id="menu-item-49649"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49649"><a
                              href="/mutual-funds/explore/nippon-funds/">Nippon India Mutual Fund</a>
                          </li>
                          <li id="menu-item-49650"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49650"><a
                              href="/mutual-funds/explore/uti-funds/">UTI Mutual Fund</a></li>
                          <li id="menu-item-49651"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49651"><a
                              href="/mutual-funds/explore/dsp-funds/">DSP Mutual Fund</a></li>
                          <li id="menu-item-49652"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49652"><a
                              href="/mutual-funds/explore/index-funds/">Index Fund</a></li>
                          <li id="menu-item-49653"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49653"><a
                              href="/mutual-funds/explore/small-cap-funds/">Small Cap Mutual Fund</a>
                          </li>
                          <li id="menu-item-49654"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49654"><a
                              href="/mutual-funds/explore/liquid-funds/">Liquid Funds</a></li>
                          <li id="menu-item-50165"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50165"><a
                              href="/amc/">Mutual Fund AMCs</a></li>
                        </ul>
                      </div>
                    </section>
                  </div>
                </div>
              </li>
            </ul>
            <li class="tab"><a href="#servicePages" val="#servicePages"><span>Tools</span> <span
                  class="expand_icon dashicons-plus"></span></a></li>
            <ul id="servicePages" class="hiding pane-container">
              <li>
                <div class="tab-content">
                  <div class="container tab-pane">
                    <section class="widget-tools widget nav_menu-81 widget_nav_menu">
                      <p class="widget__title">Tools</p>
                      <div class="menu-footer-tools-container">
                        <ul id="menu-footer-tools" class="menu">
                          <li id="menu-item-49658"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49658"><a
                              href="/calculator/brokerage-calculator/">Brokerage calculator</a></li>
                          <!-- <li id="menu-item-49659"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49659"><a
                              href="/calculator/span-calculator/">Margin Calculator</a></li> -->
                          <li id="menu-item-49660"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49660"><a
                              href="/calculator/sip-calculator/">SIP Calculator</a></li>
                          <li id="menu-item-49661"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49661"><a
                              href="/calculator/swp/">SWP Calculator</a></li>
                          <li id="menu-item-49662"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49662"><a
                              href="/calculator/nps/">NPS Calculator</a></li>
                          <li id="menu-item-49663"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49663"><a
                              href="/calculator/ppf-public-provident-fund/">PPF Calculator</a></li>
                          <li id="menu-item-49664"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49664"><a
                              href="/calculator/cagr-calculate-compound-annual-growth-rate/">CAGR
                              Calculator</a></li>
                          <li id="menu-item-49665"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49665"><a
                              href="/calculator/compound-interest/">Compound Interest calculator</a>
                          </li>
                          <li id="menu-item-49666"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49666"><a
                              href="/calculator/gratuity/">Gratuity calculator</a></li>
                          <li id="menu-item-49667"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49667"><a
                              href="/calculator/simple-interest/">Simple Interest Calculator</a></li>
                          <li id="menu-item-49668"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49668"><a
                              href="/calculator/hra-house-rent-allowance-calculator/">HRA
                              Calculator</a></li>
                          <li id="menu-item-49669"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49669"><a
                              href="/calculator/fd-fixed-deposit/">FD Calculator</a></li>
                          <li id="menu-item-49670"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49670"><a
                              href="/calculator/gst/">GST Calculator</a></li>
                          <li id="menu-item-49671"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49671"><a
                              href="/calculator/mutual-fund-return/">Mutual Funds Return
                              Calculator</a></li>
                          <li id="menu-item-49672"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49672"><a
                              href="/calculator/emi-calculator/">EMI Calculator</a></li>
                        </ul>
                      </div>
                    </section>
                  </div>
                </div>
              </li>
            </ul>
            <li class="tab"><a href="#hcMobile" val="#hcMobile"><span>IPO</span> <span
                  class="expand_icon dashicons-plus"></span></a></li>
            <ul id="hcMobile" class="hiding pane-container">
              <li>
                <div class="tab-content">
                  <div class="container tab-pane">
                    <section class="widget nav_menu-54 widget_nav_menu">
                      <div class="menu-footer-ipo-new-container">
                        <ul id="menu-footer-ipo-new" class="menu">
                          <li id="menu-item-49676"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49676"><a
                              href="/ipo/">All IPO</a></li>
                          <li id="menu-item-50168"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50168"><a
                              href="/ipo/current-ipo/">Open IPO</a></li>
                          <li id="menu-item-50169"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50169"><a
                              href="/ipo/upcoming-ipo/">Upcoming IPO</a></li>
                          <li id="menu-item-50170"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50170"><a
                              href="/ipo/ipo-recently-listed/">Recently Listed IPO</a></li>
                          <li id="menu-item-50171"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50171"><a
                              href="/ipo/closed-ipo/">Closed IPO</a></li>
                          <li id="menu-item-50172"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50172"><a
                              href="/ipo/sme/">All SME IPO</a></li>
                          <li id="menu-item-50173"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50173"><a
                              href="/ipo/sme/current-sme-ipo/">Open SME IPO</a></li>
                          <li id="menu-item-50174"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50174"><a
                              href="/ipo/sme/upcoming-sme-ipo/">Upcoming SME IPO</a></li>
                          <li id="menu-item-50175"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50175"><a
                              href="/ipo/sme/recently-listed-sme-ipo/">Recently Listed SME IPO</a>
                          </li>
                          <li id="menu-item-50176"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50176"><a
                              href="/ipo/sme/sme-closed-ipo/">Closed SME IPO</a></li>
                          <li id="menu-item-50177"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50177"><a
                              href="/ipo/mainboard/">All Mainboard IPO</a></li>
                          <li id="menu-item-50178"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50178"><a
                              href="/ipo/mainboard/current-mainboard-ipo/">Open Mainboard IPO</a></li>
                          <li id="menu-item-50179"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50179"><a
                              href="/ipo/mainboard/upcoming-mainboard-ipo/">Upcoming Mainboard IPO</a>
                          </li>
                          <li id="menu-item-50180"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50180"><a
                              href="/ipo/mainboard/recently-listed-mainboard-ipo/">Recently Listed
                              Mainboard IPO</a></li>
                          <li id="menu-item-50181"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50181"><a
                              href="/ipo/mainboard/mainboard-closed-ipo/">Closed Mainboard IPO</a>
                          </li>
                        </ul>
                      </div>
                    </section>
                  </div>
                </div>
              </li>
            </ul>
            <li class="tab"><a href="#moremobile" val="#moremobile"><span>Learning Center</span> <span
                  class="expand_icon dashicons-plus"></span></a></li>
            <ul id="moremobile" class="hiding pane-container">
              <li>
                <div class="tab-content">
                  <div class="container tab-pane">
                    <section class="widget-demat-account-guide widget nav_menu-8 widget_nav_menu">
                      <p class="widget__title">Demat Account Guide</p>
                      <div class="menu-footer-learning-center-new-container">
                        <ul id="menu-footer-learning-center-new" class="menu">
                          <li id="menu-item-49680"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49680"><a
                              href="/uplearn/webinars/">Webinars</a></li>
                          <li id="menu-item-49681"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49681"><a
                              href="/uplearn/courses/">Courses</a></li>
                          <li id="menu-item-49682"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49682"><a
                              href="/uplearn">Uplearn</a></li>
                          <li id="menu-item-49683"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49683"><a
                              href="/learning-center/demat-account/">Demat Account Guide</a></li>
                          <li id="menu-item-49684"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49684"><a
                              href="/learning-center/trading-account/">Trading Account Guide</a></li>
                          <li id="menu-item-49685"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49685"><a
                              href="/learning-center/online-trading/">Online Trading Guide</a></li>
                          <li id="menu-item-49686"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49686"><a
                              href="/learning-center/intraday-trading/">Intraday Trading Guide</a>
                          </li>
                          <li id="menu-item-49687"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49687"><a
                              href="/learning-center/futures-and-options/">Futures and Options
                              Guide</a></li>
                          <li id="menu-item-49688"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49688"><a
                              href="/learning-center/mutual-funds/">Mutual Funds Guide</a></li>
                          <li id="menu-item-49689"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49689"><a
                              href="/learning-center/share-market/">Share Market Guide</a></li>
                          <li id="menu-item-49690"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49690"><a
                              href="/learning-center/ipo/">IPO Guide</a></li>
                          <li id="menu-item-49691"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49691"><a
                              href="/learning-center/stock-broker/">Stock Broker Guide</a></li>
                        </ul>
                      </div>
                    </section>
                  </div>
                </div>
              </li>
            </ul>

            <li class="tab"><a href="#banMobile" val="#banMobile"><span>Commodities</span> <span
                  class="expand_icon dashicons-plus"></span></a></li>
            <ul id="banMobile" class="hiding pane-container">
              <li>
                <div class="tab-content">
                  <div class="container tab-pane">
                    <section class="widget-comm widget nav_menu-80 widget_nav_menu">
                      <p class="widget__title">comm</p>
                      <div class="menu-footer-commodities-container">
                        <ul id="menu-footer-commodities" class="menu">
                          <li id="menu-item-49695"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49695"><a
                              href="/gold-rates/">Gold</a></li>
                          <li id="menu-item-49696"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49696"><a
                              href="/silver-rates/">Silver</a></li>
                          <li id="menu-item-49697"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49697"><a
                              href="/petrol-price/">Petrol</a></li>
                        </ul>
                      </div>
                    </section>
                  </div>
                </div>
              </li>
            </ul>

          </ul>
        </div>

        <div class="footer-support-desktop-support-custm">

          <div class="tab_footer_section_popular">
            <button class="arrow left-arrow">&lt;</button>
            <ul class="footer-tabs">
              <li class="tab hidden">
                <a href="#lc" val="#lc">
                  <span>Popular Stocks</span>
                </a>
              </li>
              <li class="tab hidden">
                <a href="#fo" val="#fo">
                  <span>Indian Indices </span>
                </a>
              </li>
              <li class="tab hidden">
                <a href="#ip" val="#ip">
                  <span>Mutual Funds </span>
                </a>
              </li>
              <li class="tab collapsed">
                <a href="#hc" val="#hc">
                  <span>Tools</span>
                </a>
              </li>
              <li class="tab">
                <a href="#sp" val="#sp">
                  <span>IPO</span>
                </a>
              </li>
              <li class="tab">
                <a href="#mr" val="#mr">
                  <span> Learning Center </span>
                </a>
              </li>
              <li class="tab">
                <a href="#co" val="#co">
                  <span> Commodities </span>
                </a>
              </li>

            </ul>
            <button class="arrow right-arrow">&gt;</button>
          </div>

          <div class="tab-content">
            <div id="lc" class="tab-pane hiding list-four-item">
              <section class="widget-popular-stocks widget nav_menu-65 widget_nav_menu">
                <p class="widget__title">Popular Stocks</p>
                <div class="menu-footer-popular-stocks-new-container">
                  <ul id="menu-footer-popular-stocks-new-1" class="menu">
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49610"><a
                        href="/stocks/indian-railway-fin-corp-l-share-price/INE053F01010/">IRFC Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49611"><a
                        href="/stocks/suzlon-energy-limited-share-price/INE040H01021/">Suzlon Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49612"><a
                        href="/stocks/indian-renewable-energy-share-price/INE202E01016/">IREDA Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49613"><a
                        href="/stocks/tata-motors-limited-share-price/INE155A01022/">Tata Motors Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50030"><a
                        href="/stocks/penny-stocks/">Penny Stocks</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49614"><a
                        href="/stocks/yes-bank-limited-share-price/INE528G01035/">Yes Bank Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49615"><a
                        href="/stocks/adani-enterprises-limited-share-price/INE423A01024/">Adani
                        Enterprise Share Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49616"><a
                        href="/stocks/hdfc-bank-ltd-share-price/INE040A01034/">HDFC Bank Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49617"><a
                        href="/stocks/nhpc-ltd-share-price/INE848E01016/">NHPC Share Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50031"><a
                        href="/stocks/stocks-under-10/">Stocks under 10</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49618"><a
                        href="/stocks/rail-vikas-nigam-limited-share-price/INE415G01027/">RVNL Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49619"><a
                        href="/stocks/state-bank-of-india-share-price/INE062A01020/">SBI Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49620"><a
                        href="/stocks/tata-power-co-ltd-share-price/INE245A01021/">Tata Power Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49621"><a
                        href="/stocks/tata-steel-limited-share-price/INE081A01020/">Tata Steel Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50032"><a
                        href="/stocks/stocks-under-20/">Stocks under 20</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49622"><a
                        href="/stocks/adani-power-ltd-share-price/INE814H01011/">Adani Power Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49623"><a
                        href="/stocks/one-97-communications-ltd-share-price/INE982J01020/">Paytm Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49624"><a
                        href="/stocks/punjab-national-bank-share-price/INE160A01022/">PNB Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49625"><a
                        href="/stocks/zomato-limited-share-price/INE758T01015/">Zomato Share Price</a>
                    </li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50033"><a
                        href="/stocks/stocks-under-50/">Stocks under 50</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49626"><a
                        href="/stocks/bharat-electronics-ltd-share-price/INE263A01024/">BEL Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49627"><a
                        href="/stocks/bhel-share-price/INE257A01026/">Bhel Share Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49628"><a
                        href="/stocks/infosys-limited-share-price/INE009A01021/">Infosys Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49629"><a
                        href="/stocks/indian-rail-tour-corp-ltd-share-price/INE335Y01020/">IRCTC Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50034"><a
                        href="/stocks/stocks-under-100/">Stocks under 100</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49630"><a
                        href="/stocks/life-insura-corp-of-india-share-price/INE0J1Y01017/">LIC Share
                        Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49631"><a
                        href="/stocks/itc-ltd-share-price/INE154A01025/">ITC Share Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49632"><a
                        href="/stocks/reliance-industries-ltd-share-price/INE002A01018/">Reliance
                        Share Price</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50035"><a
                        href="/stocks/stocks-under-200/">Stocks under 200</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50036"><a
                        href="/stocks/stocks-under-500/">Stocks under 500</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50037"><a
                        href="/stocks/stocks-under-1000/">Stocks under 1000</a></li>
                  </ul>
                </div>
              </section> <span class="clearfix"></span>
            </div>
            <div id="fo" class="tab-pane hiding list-four-item">
              <section class="widget-indian-stocks widget nav_menu-66 widget_nav_menu">
                <p class="widget__title">Indian Stocks</p>
                <div class="menu-footer-indian-stocks-container">
                  <ul id="menu-footer-indian-stocks-1" class="menu">
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31706"><a
                        href="/indices/nifty-50-share-price/">Nifty 50</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31707"><a
                        href="/indices/nifty-next-50-share-price/">Nifty Next 50</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31708"><a
                        href="/indices/nifty-bank-share-price/">Nifty Bank</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31709"><a
                        href="/indices/nifty-100-share-price/">Nifty 100</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31710"><a
                        href="/indices/nifty-200-share-price/">Nifty 200</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31711"><a
                        href="/indices/nifty-500-share-price/">Nifty 500</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31712"><a
                        href="/indices/nifty-midcap-50-share-price/">Nifty Midcap 50</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31713"><a
                        href="/indices/nifty-smlcap-50-share-price/">NIFTY SMLCAP 50</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31714"><a
                        href="/indices/india-vix-share-price/">India VIX</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31715"><a
                        href="/indices/sensex-share-price/">SENSEX</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31716"><a
                        href="/indices/bse100-share-price/">BSE100</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49636"><a
                        href="/indices/lrgcap-share-price/">BSE LargeCap</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49637"><a
                        href="/indices/midcap-share-price/">BSE MidCap</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49638"><a
                        href="/indices/smlcap-share-price/">BSE SmallCap</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49639"><a
                        href="/indices/bse500-share-price/">BSE500</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49640"><a
                        href="/indices/allcap-share-price/">BSE AllCap</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49641"><a
                        href="/indices/bse200-share-price/">BSE 200</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49642"><a
                        href="/indices/bseipo-share-price/">BSE IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49643"><a
                        href="/indices/smeipo-share-price/">BSE SME IPO</a></li>
                  </ul>
                </div>
              </section> <span class="clearfix"></span>
            </div>
            <div id="ip" class="tab-pane hiding list-four-item">
              <section class="widget-funds widget nav_menu-79 widget_nav_menu">
                <p class="widget__title">funds</p>
                <div class="menu-footer-mutual-funds-container">
                  <ul id="menu-footer-mutual-funds-1" class="menu">
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49647"><a
                        href="/mutual-funds/explore/sbi-funds/">SBI Mutual Fund</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49648"><a
                        href="/mutual-funds/explore/hdfc-funds/">HDFC Mutual Fund</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49649"><a
                        href="/mutual-funds/explore/nippon-funds/">Nippon India Mutual Fund</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49650"><a
                        href="/mutual-funds/explore/uti-funds/">UTI Mutual Fund</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49651"><a
                        href="/mutual-funds/explore/dsp-funds/">DSP Mutual Fund</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49652"><a
                        href="/mutual-funds/explore/index-funds/">Index Fund</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49653"><a
                        href="/mutual-funds/explore/small-cap-funds/">Small Cap Mutual Fund</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49654"><a
                        href="/mutual-funds/explore/liquid-funds/">Liquid Funds</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50165"><a
                        href="/amc/">Mutual Fund AMCs</a></li>
                  </ul>
                </div>
              </section> <span class="clearfix"></span>
            </div>
            <div id="hc" class="tab-pane hiding list-four-item flexed" style="display: block;">
              <section class="widget-tools widget nav_menu-81 widget_nav_menu">
                <p class="widget__title">Tools</p>
                <div class="menu-footer-tools-container">
                  <ul id="menu-footer-tools-1" class="menu">
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49658"><a
                        href="/calculator/brokerage-calculator/">Brokerage calculator</a></li>
                    <!-- <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49659"><a
                        href="/calculator/span-calculator/">Margin Calculator</a></li> -->
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49660"><a
                        href="/calculator/sip-calculator/">SIP Calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49661"><a
                        href="/calculator/swp/">SWP Calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49662"><a
                        href="/calculator/nps/">NPS Calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49663"><a
                        href="/calculator/ppf-public-provident-fund/">PPF Calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49664"><a
                        href="/calculator/cagr-calculate-compound-annual-growth-rate/">CAGR
                        Calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49665"><a
                        href="/calculator/compound-interest/">Compound Interest calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49666"><a
                        href="/calculator/gratuity/">Gratuity calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49667"><a
                        href="/calculator/simple-interest/">Simple Interest Calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49668"><a
                        href="/calculator/hra-house-rent-allowance-calculator/">HRA Calculator</a>
                    </li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49669"><a
                        href="/calculator/fd-fixed-deposit/">FD Calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49670"><a
                        href="/calculator/gst/">GST Calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49671"><a
                        href="/calculator/mutual-fund-return/">Mutual Funds Return Calculator</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49672"><a
                        href="/calculator/emi-calculator/">EMI Calculator</a></li>
                  </ul>
                </div>
              </section> <span class="clearfix"></span>
            </div>
            <div id="sp" class="tab-pane hiding">
              <section class="widget nav_menu-54 widget_nav_menu">
                <div class="menu-footer-ipo-new-container">
                  <ul id="menu-footer-ipo-new-1" class="menu">
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49676"><a
                        href="/ipo/">All IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50168"><a
                        href="/ipo/current-ipo/">Open IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50169"><a
                        href="/ipo/upcoming-ipo/">Upcoming IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50170"><a
                        href="/ipo/ipo-recently-listed/">Recently Listed IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50171"><a
                        href="/ipo/closed-ipo/">Closed IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50172"><a
                        href="/ipo/sme/">All SME IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50173"><a
                        href="/ipo/sme/current-sme-ipo/">Open SME IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50174"><a
                        href="/ipo/sme/upcoming-sme-ipo/">Upcoming SME IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50175"><a
                        href="/ipo/sme/recently-listed-sme-ipo/">Recently Listed SME IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50176"><a
                        href="/ipo/sme/sme-closed-ipo/">Closed SME IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50177"><a
                        href="/ipo/mainboard/">All Mainboard IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50178"><a
                        href="/ipo/mainboard/current-mainboard-ipo/">Open Mainboard IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50179"><a
                        href="/ipo/mainboard/upcoming-mainboard-ipo/">Upcoming Mainboard IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50180"><a
                        href="/ipo/mainboard/recently-listed-mainboard-ipo/">Recently Listed Mainboard
                        IPO</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-50181"><a
                        href="/ipo/mainboard/mainboard-closed-ipo/">Closed Mainboard IPO</a></li>
                  </ul>
                </div>
              </section> <span class="clearfix"></span>
            </div>
            <div id="mr" class="tab-pane hiding list-four-item">
              <section class="widget-demat-account-guide widget nav_menu-8 widget_nav_menu">
                <p class="widget__title">Demat Account Guide</p>
                <div class="menu-footer-learning-center-new-container">
                  <ul id="menu-footer-learning-center-new-1" class="menu">
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49680"><a
                        href="/uplearn/webinars/">Webinars</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49681"><a
                        href="/uplearn/courses/">Courses</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49682"><a
                        href="/uplearn">Uplearn</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49683"><a
                        href="/learning-center/demat-account/">Demat Account Guide</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49684"><a
                        href="/learning-center/trading-account/">Trading Account Guide</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49685"><a
                        href="/learning-center/online-trading/">Online Trading Guide</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49686"><a
                        href="/learning-center/intraday-trading/">Intraday Trading Guide</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49687"><a
                        href="/learning-center/futures-and-options/">Futures and Options Guide</a>
                    </li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49688"><a
                        href="/learning-center/mutual-funds/">Mutual Funds Guide</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49689"><a
                        href="/learning-center/share-market/">Share Market Guide</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49690"><a
                        href="/learning-center/ipo/">IPO Guide</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49691"><a
                        href="/learning-center/stock-broker/">Stock Broker Guide</a></li>
                  </ul>
                </div>
              </section> <span class="clearfix"></span>
            </div>
            <div id="co" class="tab-pane hiding list-four-item">
              <section class="widget-comm widget nav_menu-80 widget_nav_menu">
                <p class="widget__title">comm</p>
                <div class="menu-footer-commodities-container">
                  <ul id="menu-footer-commodities-1" class="menu">
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49695"><a
                        href="/gold-rates/">Gold</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49696"><a
                        href="/silver-rates/">Silver</a></li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49697"><a
                        href="/petrol-price/">Petrol</a></li>
                  </ul>
                </div>
              </section> <span class="clearfix"></span>
            </div>
          </div>

        </div>

        <div class="alphbed-numbers-list">
          <div class="left-area-lable"><span>Stocks</span></div>
          <div class="right-area-lable">
            <ul class="">
              <li><a href="/stocks-market/share-market-listed-company-in-india/a/" class="">A</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/b/" class="">B</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/c/" class="">C</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/d/" class="">D</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/e/" class="">E</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/f/" class="">F</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/g/" class="">G</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/h/" class="">H</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/i/" class="">I</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/j/" class="">J</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/k/" class="">K</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/l/" class="">L</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/m/" class="">M</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/n/" class="">N</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/o/" class="">O</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/p/" class="">P</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/q/" class="">Q</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/r/" class="">R</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/s/" class="">S</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/t/" class="">T</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/u/" class="">U</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/v/" class="">V</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/w/" class="">W</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/x/" class="">X</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/y/" class="">Y</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/z/" class="">Z</a></li>
              <li><a href="/stocks-market/share-market-listed-company-in-india/others/"
                  class="">Others</a></li>
            </ul>
          </div>
        </div>

        <div class="flex-footer-secton-4 desktop-show">
          <section class="widget-products widget nav_menu-4 widget_nav_menu">
            <p class="widget__title">Products</p>
            <div class="menu-footer-products-container">
              <ul id="menu-footer-products" class="menu">
                <li id="menu-item-31670"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31670"><a
                    href="/upstox-pro-web-online-trading/">Pro Web</a></li>
                <li id="menu-item-31671"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31671"><a
                    href="/upstox-pro-mobile-trading-app/">Pro Mobile</a></li>
                <li id="menu-item-35327"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-35327"><a
                    href="/mutual-funds/">Mutual Funds</a></li>
                <li id="menu-item-31673"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31673"><a
                    href="/ipo-initial-public-offering">IPOs</a></li>
                <li id="menu-item-31674"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31674"><a
                    href="/trade-in-futures-and-options/">Futures And Options</a></li>
                <li id="menu-item-31675"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31675"><a
                    href="/stocks/">Stocks</a></li>
                <li id="menu-item-31676"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31676"><a
                    href="/indices/">Indices</a></li>
                <li id="menu-item-31677"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31677"><a
                    href="/uplink/">Trading API</a></li>
                <li id="menu-item-38441"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-38441"><a
                    href="/free-chart-view-for-live-trading/">Upstox x TradingView</a></li>
                <li id="menu-item-49574"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49574"><a
                    href="/trade-on-charts/">Chart 360</a></li>
              </ul>
            </div>
          </section>
          <section class="widget-company widget nav_menu-2 widget_nav_menu">
            <p class="widget__title">Company</p>
            <div class="menu-footer-company-container">
              <ul id="menu-footer-company" class="menu">
                <li id="menu-item-7516"
                  class="clevertap_About menu-item menu-item-type-post_type menu-item-object-page menu-item-7516"><a
                    href="/about/">About Us</a></li>
                <li id="menu-item-7725"
                  class="clevertap_Blog menu-item menu-item-type-post_type menu-item-object-page menu-item-7725"><a
                    href="/market-talk/">Market Talk</a></li>
                <li id="menu-item-10325"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-10325"><a
                    href="/brokerage-charges/">Brokerage Charges</a></li>
                <li id="menu-item-10687"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-10687"><a
                    href="/announcements/">Announcements</a></li>
                <li id="menu-item-13252"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-13252"><a
                    href="/press-releases/">Press Releases</a></li>
                <li id="menu-item-48962"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-48962"><a
                    href="https://marketing-creative-and-docs.s3.ap-south-1.amazonaws.com/Upstox+Brand+guides+%26+Logo+Files.zip">Media
                    Kit</a></li>
                <li id="menu-item-20197"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-20197"><a
                    href="/bug-bounty/">Bug Bounty Program</a></li>
                <li id="menu-item-32179"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-32179"><a
                    href="/become-sub-broker/">Partner with us</a></li>
                <li id="menu-item-39605"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-39605"><a
                    href="/contact-us/">Contact Us</a></li>
                <li id="menu-item-9922"
                  class="clevertap_RnE menu-item menu-item-type-post_type menu-item-object-page menu-item-9922"><a
                    href="/refer-and-earn/">Refer and Earn</a></li>
                <li id="menu-item-49593"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49593"><a
                    href="/support/home">Help Center</a></li>
                <li id="menu-item-49594"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49594"><a
                    href="/glossary/">Glossary</a></li>
              </ul>
            </div>
          </section>
          <section class="widget-upstox widget nav_menu-38 widget_nav_menu">
            <p class="widget__title">Upstox</p>
            <div class="menu-footer-service-pages-container">
              <ul id="menu-footer-service-pages" class="menu">
                <li id="menu-item-31693"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31693"><a
                    href="https://wa.me/+917092362098">Demat Account</a></li>
                <li id="menu-item-31696"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31696"><a
                    href="/equity-trading/">Equity Trading</a></li>
                <li id="menu-item-31694"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31694"><a
                    href="/trading-account/">Trading Account</a></li>
                <li id="menu-item-31695"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31695"><a
                    href="/commodity-trading/">Commodity Trading</a></li>
                <li id="menu-item-42657"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-42657"><a
                    href="/open-mutual-fund-account/">Open Mutual Fund Account</a></li>
                <li id="menu-item-31697"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31697"><a
                    href="/forms/">Download Forms</a></li>
              </ul>
            </div>
          </section>
        </div>

        <div class="flex-footer-secton-4 mobile-show">
          <section class="widget-products widget nav_menu-4 widget_nav_menu">
            <p class="widget__title">Products</p>
            <div class="menu-footer-products-container">
              <ul id="menu-footer-products-1" class="menu">
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31670"><a
                    href="/upstox-pro-web-online-trading/">Pro Web</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31671"><a
                    href="/upstox-pro-mobile-trading-app/">Pro Mobile</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-35327"><a
                    href="/mutual-funds/">Mutual Funds</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31673"><a
                    href="/ipo-initial-public-offering">IPOs</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31674"><a
                    href="/trade-in-futures-and-options/">Futures And Options</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31675"><a
                    href="/stocks/">Stocks</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31676"><a
                    href="/indices/">Indices</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31677"><a
                    href="/uplink/">Trading API</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-38441"><a
                    href="/free-chart-view-for-live-trading/">Upstox x TradingView</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49574"><a
                    href="/trade-on-charts/">Chart 360</a></li>
              </ul>
            </div>
          </section>
          <section class="widget-company widget nav_menu-2 widget_nav_menu">
            <p class="widget__title">Company</p>
            <div class="menu-footer-company-container">
              <ul id="menu-footer-company-1" class="menu">
                <li class="clevertap_About menu-item menu-item-type-post_type menu-item-object-page menu-item-7516"><a
                    href="/about/">About Us</a></li>
                <li class="clevertap_Blog menu-item menu-item-type-post_type menu-item-object-page menu-item-7725"><a
                    href="/market-talk/">Market Talk</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-10325"><a
                    href="/brokerage-charges/">Brokerage Charges</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-10687"><a
                    href="/announcements/">Announcements</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-13252"><a
                    href="/press-releases/">Press Releases</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-48962"><a
                    href="https://marketing-creative-and-docs.s3.ap-south-1.amazonaws.com/Upstox+Brand+guides+%26+Logo+Files.zip">Media
                    Kit</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-20197"><a
                    href="/bug-bounty/">Bug Bounty Program</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-32179"><a
                    href="/become-sub-broker/">Partner with us</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-39605"><a
                    href="/contact-us/">Contact Us</a></li>
                <li class="clevertap_RnE menu-item menu-item-type-post_type menu-item-object-page menu-item-9922"><a
                    href="/refer-and-earn/">Refer and Earn</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49593"><a
                    href="/support/home">Help Center</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49594"><a
                    href="/glossary/">Glossary</a></li>
              </ul>
            </div>
          </section>
          <section class="widget-upstox widget nav_menu-38 widget_nav_menu">
            <p class="widget__title">Upstox</p>
            <div class="menu-footer-service-pages-container">
              <ul id="menu-footer-service-pages-1" class="menu">
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31693"><a
                    href="https://wa.me/+917092362098">Demat Account</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31696"><a
                    href="/equity-trading/">Equity Trading</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31694"><a
                    href="/trading-account/">Trading Account</a></li>
                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-31695"><a
                    href="/commodity-trading/">Commodity Trading</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-42657"><a
                    href="/open-mutual-fund-account/">Open Mutual Fund Account</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31697"><a
                    href="/forms/">Download Forms</a></li>
              </ul>
            </div>
          </section>
        </div>

        <div class="flex-footer-secton-5">
          <div class="investors-footer">
            <p>Attention Investors & Disclaimer <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g id="Chevron left" clip-path="url(#clip0_5115_26378)">
                  <path id="Vector"
                    d="M7.41 8.7775L6 10.1875L12 16.1875L18 10.1875L16.59 8.7775L12 13.3575L7.41 8.7775Z" fill="white">
                  </path>
                </g>
                <defs>
                  <clipPath id="clip0_5115_26378">
                    <rect width="24" height="24" fill="white" transform="matrix(0 -1 1 0 0 24.1875)"></rect>
                  </clipPath>
                </defs>
              </svg> </p>
          </div>
          <div class="footer-tc" id="tnc">
            <p>Upstox Securities Pvt. Ltd.: SEBI Registration No. INZ000315837 | NSE TM Code: 13942 | BSE TM Code: 6155
              | CDSL Reg No.: IN-DP-761-2024 | CIN: U65100DL2021PTC376860 | Compliance Officer: Mr. Kapil Jaikalyani.
              Tel No.: (022) 24229920. Email ID: <a href="mailto:compliance@upstox.com">compliance@upstox.com</a> |
              Registered Address: 809, New Delhi House, Barakhamba Road, Connaught Place, New Delhi - 110001 | RKSV
              Commodities India Pvt. Ltd.: SEBI Registration No.: INZ000015837 | MCX TM Code: 46510 | NSE TM Code: 90393
              | CIN: U74900DL2009PTC189166 | Compliance Officer: Mr. Amit Lalan. Tel No.: (022) 24229920. Email ID: <a
                href="mailto:compliance@rksv.in">compliance@rksv.in</a> | Registered Address: 807, New Delhi House,
              Barakhamba Road, Connaught Place, New Delhi - 110001. Correspondence Address: 30th Floor, Sunshine Tower,
              Senapati Bapat Marg, Dadar (West), Mumbai - 400013. | For any complaints, email at <a
                href="mailto:complaints@upstox.com">complaints@upstox.com</a> and <a
                href="mailto:support@upstox.icu">support@upstox.icu</a>.</p>
            <p>Procedure to file a complaint on <a href="https://scores.sebi.gov.in/">SEBI SCORES</a>: Register on the
              SCORES portal. Mandatory details for filing complaints on SCORES include: Name, PAN, Address, Mobile
              Number, and E-mail ID. Benefits include effective communication and speedy redressal of grievances. Please
              ensure you carefully read the <a href="/forms/">Risk Disclosure Document as prescribed
                by SEBI</a>, along with our <a href="/terms-of-use-and-privacy-policy/">Terms of Use
                and Privacy Policy</a>.</p>
            <p>Upstox Securities Private Limited is a wholly owned subsidiary of RKSV Securities India Private Limited
              and RKSV Commodities India Private Limited is an associate of RKSV Securities India Private Limited.</p>
            <p>Disclaimer: Investment in securities market are subject to market risks, read all the related documents
              carefully before investing.<br>
              *Brokerage will not exceed the SEBI prescribed limit.</p>
            <p>Risk disclosures on derivatives -</p>
            <ul>
              <li>9 out of 10 individual traders in equity Futures and Options Segment, incurred net losses.</li>
              <li>On an average, loss makers registered net trading loss close to ₹ 50,000</li>
              <li>Over and above the net trading losses incurred, loss makers expended an additional 28% of net trading
                losses as transaction costs.</li>
              <li>Those making net trading profits, incurred between 15% to 50% of such profits as transaction cost.
              </li>
            </ul>
            <p>Mutual Funds: Top rated funds do not constitute any advice. Research data is powered by Morningstar.
              Please read the offer documents carefully before investing. Upstox shall not accept any liability arising
              out of your investments.<br>
              These are not Exchange traded products, and the Member is just acting as distributor. All disputes with
              respect to the distribution activity, would not have access to Exchange investor redressal forum or
              Arbitration mechanism.</p>
            <p>Attention Investors: As per NSE circular dated July 6, 2022, BSE circular dated July 6, 2022, MCX
              circular dated July 11, 2022 investors are cautioned to abstain them from dealing in any schemes of
              unauthorised collective investments/portfolio management, indicative/ guaranteed/fixed returns / payments
              etc. Investors are further cautioned to avoid practices like:<br>
              a) Sharing i) trading credentials – login id &amp; passwords including OTP’s., ii) trading strategies,
              iii) position details.<br>
              b) Trading in leveraged products /derivatives like Options without proper understanding, which could lead
              to losses.<br>
              c) Writing/ selling options or trading in option strategies based on tips, without basic knowledge &amp;
              understanding of the product and its risks<br>
              d) Dealing in unsolicited tips through like Whatsapp, Telegram, Instagram, YouTube, Facebook, SMS, calls,
              etc.<br>
              e) Trading / Trading in “Options” based on recommendations from unauthorised / unregistered investment
              advisors and influencers.</p>
            <p>Kindly, read the Advisory Guidelines For Investors as prescribed by the Exchange with reference to their
              circular dated 27th August, 2021 regarding investor awareness and safeguarding client’s assets : <a
                href="https://bit.ly/3jwnuwA">Advisory Guidelines For Investors</a></p>
            <p>Kindly, read the advisory as prescribed by the Exchange with reference to their circular dated January
              14, 2022 regarding Updation of mandatory KYC fields by March 31, 2022: <a
                href="https://uptx.to/KYC-Updation">KYC Updation</a></p>
            <p>Attention Investors: Prevent unauthorised transactions in your Demat account by updating your mobile
              number with your depository participant. Receive alerts on your registered mobile number for debit and
              other important transactions in your Demat account directly from CDSL on the same day. Prevent
              unauthorised transactions in your Trading account by updating your mobile numbers/email addresses with
              your stock brokers. Receive information on your transactions directly from the Exchange on your
              mobile/email at the end of the day. Issued in the interest of investors. KYC is a one-time exercise while
              dealing in securities markets - once KYC is done through a SEBI-registered intermediary (broker, DP,
              Mutual Fund, etc.), you need not undergo the same process again when you approach another intermediary. As
              a business, we don’t give stock tips and have not authorised anyone to trade on behalf of others. If you
              find anyone claiming to be part of Upstox or RKSV and offering such services, please send us an email at
              <a href="mailto:complaints@upstox.com">complaints@upstox.com</a> and <a
                href="mailto:support@upstox.icu">support@upstox.icu</a>.</p>
            <p>No need to issue cheques by investors while subscribing to IPO. Just write the bank account number and
              sign in the application form to authorise your bank to make payment in case of allotment. No worries for
              refund as the money remains in investor’s account.
              Stockbrokers can accept securities as margin from their clients only by way of a pledge in the depository
              system w.e.f. 1st September 2020.<br>
              Update your email ID and mobile number with your stockbroker/depository participant and receive an OTP
              directly from the depository on your registered email ID and/or mobile number to create a pledge.<br>
              Check your securities/mutual funds/bonds in the Consolidated Account Statement (CAS) issued by NSDL/CDSL
              every month.</p>
            <p>Attention Investors: SEBI has established an Online Dispute Resolution Portal (ODR Portal) for resolving
              disputes in the Indian Securities Market. This circular streamlines the existing dispute resolution
              mechanism, offering online conciliation and arbitration, benefiting investors and listed companies. <a
                href="https://www.sebi.gov.in/legal/circulars/jul-2023/online-resolution-of-disputes-in-the-indian-securities-market_74794.html">https://www.sebi.gov.in/legal/circulars/jul-2023/online-resolution-of-disputes-in-the-indian-securities-market_74794.html</a>
            </p>
            <p>ODR portal for Investors - <a href="https://smartodr.in/login">https://smartodr.in/login</a></p>



          </div>
        </div>
        <div class="footer-last">
          <div class="container custom-container">
            <div class="footer-copyright">
              <div class="legal">
                <ul id="menu-footer-menu" class="legal top">
                  <li id="menu-item-35246"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-35246"><a
                      href="/terms-of-use-and-privacy-policy/">Terms of Use and Privacy Policy</a>
                  </li>
                  <li id="menu-item-35238"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-35238"><a
                      href="/trust-security/">Trust &#038; Security</a></li>
                  <li id="menu-item-35239"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-35239"><a
                      href="/">Careers</a></li>
                  <li id="menu-item-35242"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-35242"><a
                      href="/investor-attention/">Investor Charter</a></li>
                  <li id="menu-item-45789"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-45789"><a
                      href="https://marketing-creative-and-docs.s3.ap-south-1.amazonaws.com/Upstreaming_Bank+/Upstreaming+Bank+Details_Website.docx.pdf">Client
                      Bank Details</a></li>
                </ul>
              </div>
              <p class="copyright">Made with <span class="heart">❤️</span> in India | Copyright &copy;
                2025, <a href="/">Upstox</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
  import { onMounted, ref, onUnmounted } from 'vue';
  onMounted(() => {
    require("@/assets/js/footer.js")
  })
  onUnmounted(() => {
  })
</script>

<style lang="scss" scoped>
</style>